import React from 'react';
import styled from 'styled-components';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ToggleSwitch = styled.button`
  position: relative;
  width: 56px;
  height: 26px;
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;

  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.5);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.4);
  }
`;

const ToggleThumb = styled.span`
  position: absolute;
  top: 2px;
  left: ${(props) => (props.$isKorean ? '2px' : '28px')};
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: var(--color-primary);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
`;

const LanguageLabel = styled.span`
  font-size: 12px;
  font-weight: ${(props) => (props.$isActive ? '600' : '400')};
  color: ${(props) => (props.$isActive ? '#fff' : 'rgba(255, 255, 255, 0.5)')};
  transition: all 0.2s ease;
  user-select: none;
  min-width: 20px;
  text-align: center;
`;

function LanguageToggle({ currentLocale, onToggle }) {
  const isKorean = currentLocale === 'ko';

  const handleToggle = () => {
    onToggle(isKorean ? 'en' : 'ko');
  };

  return (
    <ToggleContainer>
      <LanguageLabel $isActive={isKorean}>KO</LanguageLabel>
      <ToggleSwitch
        onClick={handleToggle}
        aria-label={`Switch to ${isKorean ? 'English' : 'Korean'}`}
        role="switch"
        aria-checked={isKorean}
      >
        <ToggleThumb $isKorean={isKorean}>{isKorean ? '한' : 'A'}</ToggleThumb>
      </ToggleSwitch>
      <LanguageLabel $isActive={!isKorean}>EN</LanguageLabel>
    </ToggleContainer>
  );
}

export default LanguageToggle;
